import { Dialog } from 'vant'

export const confirm = (options) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (options.beforeConfirm || options.beforeCancel) {
        options.beforeClose = (action, done) => {
          if (action === 'confirm') {
            if (options.beforeConfirm) {
              options.beforeConfirm(done)
            } else {
              done()
            }
          } else if (options.beforeCancel) {
            options.beforeCancel(done)
          } else {
            done()
          }
        }
      }

      await Dialog.confirm(options)
      resolve(true)
    } catch (error) {
      resolve(false)
    }
  })
}

export const alert = Dialog.alert.bind(Dialog)
